import React from 'react';
import { motion } from 'framer-motion';

const PrivacyTVVerse = () => {
  return (
    <div className="pt-24 pb-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 legal-content">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <span className="text-accent-red font-semibold tracking-wider text-sm uppercase mb-2 block">App Specific Policy</span>
        <h1>TVVerse Privacy Policy</h1>
        <p className="text-sm border-l-2 border-accent-red pl-4 mb-8">
          Last Updated: March 2026
        </p>

        <p>
          This document outlines the specific privacy practices for <strong>TVVerse</strong>, our M3U playlist player. It serves as an addendum to the general MediaVerse Labs Privacy Policy.
        </p>

        <h2>1. Zero Data Collection</h2>
        <p>
          TVVerse does not collect, transmit, or store any personal information on our servers. We do not track who you are, what playlists you load, or what channels you watch.
        </p>

        <h2>2. Local Data Storage</h2>
        <p>
          All data related to TVVerse is stored entirely locally on your Windows device. This data is stored in your user's AppData directory: <code>%APPDATA%\TVVerse</code>. This includes:
        </p>
        <ul>
          <li>M3U playlist files or URLs added by the user.</li>
          <li>Favorite channels and viewing history.</li>
          <li>Application settings and interface preferences.</li>
        </ul>

        <h2>3. Network Connections</h2>
        <p>
          TVVerse only makes network requests necessary for its core functionality:
        </p>
        <ul>
          <li><strong>Playlist Loading:</strong> Downloading M3U files from the URLs you explicitly provide.</li>
          <li><strong>Streaming:</strong> Connecting directly to the media streams specified in your playlist.</li>
          <li><strong>Metadata:</strong> Fetching public channel info and logos directly from open-source APIs.</li>
        </ul>

        <h2>4. No Analytics, Telemetry, or Cookies</h2>
        <p>
          There is no telemetry, analytics code, or cookies embedded within TVVerse. Your usage remains 100% private.
        </p>

        <h2>5. Contact</h2>
        <p>
          For privacy inquiries: <a href="mailto:hello@mediaverselabs.com">hello@mediaverselabs.com</a>
        </p>
      </motion.div>
    </div>
  );
};

export default PrivacyTVVerse;